(function () {
  'use strict';

  var SCORE_CLASS = 'loox-rating-score';
  var LABEL_SELECTOR = 'span.loox-rating-label';

  function hasWrapped(el) {
    if (!el) return false;
    if (el.querySelector('.' + SCORE_CLASS)) return true;
    return false;
  }

  function wrapScoreInElement(el) {
    try {
      if (!el || hasWrapped(el)) return;
      // Work with innerHTML to preserve NBSP and spacing as produced by the app
      var html = el.innerHTML;
      // Regex to match the first score like 4.9/5 or 4,9/5 with optional spaces around '/'
      var re = /(\d+(?:[\.,]\d+)?\s*\/\s*\d+)/;
      if (!re.test(html)) return;
      // Replace only the first occurrence
      var newHtml = html.replace(re, function (m) {
        return '<span class="' + SCORE_CLASS + '">' + m + '</span>';
      });
      if (newHtml !== html) {
        el.innerHTML = newHtml;
      }
    } catch (e) {
      // Fail silently to avoid breaking the page
    }
  }

  function processExisting() {
    var nodes = document.querySelectorAll(LABEL_SELECTOR);
    if (!nodes || !nodes.length) return false;
    nodes.forEach(function (n) { wrapScoreInElement(n); });
    return nodes.length > 0;
  }

  function observeForLabels(root) {
    var target = root || document.body;
    if (!target) return function () {};

    // Process any current labels first
    processExisting();

    var observer = new MutationObserver(function (mutations) {
      var needsScan = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          // Check added nodes
          m.addedNodes && m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { // ELEMENT_NODE
              if (node.matches && node.matches(LABEL_SELECTOR)) {
                wrapScoreInElement(node);
              } else {
                var labels = node.querySelectorAll ? node.querySelectorAll(LABEL_SELECTOR) : [];
                labels && labels.forEach(function (el) { wrapScoreInElement(el); });
              }
            }
          });
        }
        if (m.type === 'characterData') {
          needsScan = true;
        }
      }
      if (needsScan) {
        processExisting();
      }
    });

    try {
      observer.observe(target, { subtree: true, childList: true, characterData: true });
    } catch (e) {
      // ignore
    }

    // Safety: stop observing after 60 seconds to avoid unnecessary work
    var timeout = setTimeout(function () { observer.disconnect(); }, 60000);

    return function cleanup() {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }

  function onReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  }

  onReady(function () {
    observeForLabels(document.body);
  });
  
  // Smooth scroll to #reviews when clicking on Loox rating content
  function supportsSmoothScroll() {
    try {
      var div = document.createElement('div');
      return 'scrollBehavior' in div.style;
    } catch (e) {
      return false;
    }
  }

  function getScrollTargetY(el) {
    try {
      var rect = el.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      return rect.top + scrollTop;
    } catch (e) {
      return 0;
    }
  }

  function getPrefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function smoothScrollToElement(target, offset) {
    if (!target) return false;

    offset = typeof offset === 'number' ? offset : 0;
    var behavior = getPrefersReducedMotion() ? 'auto' : 'smooth';

    if (!offset) {
      try {
        if (target.scrollIntoView) {
          target.scrollIntoView({ behavior: behavior, block: 'start' });
          return true;
        }
      } catch (e) {
        // fallback below
      }
    }

    var y = getScrollTargetY(target) + offset;
    try {
      if (supportsSmoothScroll()) {
        window.scrollTo({ top: y, behavior: behavior });
      } else {
        window.scrollTo(0, y);
      }
    } catch (e) {
      window.scrollTo(0, y);
    }
    return true;
  }

  function smoothScrollToReviews(offset) {
    var target =
      document.getElementById('looxReviewsFrame') ||
      document.getElementById('reviews');
    return smoothScrollToElement(target, offset);
  }

  function initLooxScrollHandler() {
    if (window.__looxScrollInit) return;
    window.__looxScrollInit = true;

    var handler = function (event) {
      try {
        var t = event.target;
        if (!t || !t.closest) return;

        var looxLink = t.closest('a[href="#looxReviewsFrame"], a[aria-label="Scroll to reviews"]');
        if (looxLink) {
          var frameTarget =
            document.getElementById('looxReviewsFrame') ||
            document.getElementById('reviews');
          if (!frameTarget) return;

          try { event.preventDefault(); } catch (e) {}
          smoothScrollToElement(frameTarget, -90);
          return;
        }

        var rating = t.closest('.loox-rating-content');
        if (!rating) return;

        var reviewsEl =
          document.getElementById('looxReviewsFrame') ||
          document.getElementById('reviews');
        if (!reviewsEl) return;

        var interactive = t.closest('a, button');
        if (interactive) {
          try { event.preventDefault(); } catch (e) {}
        }

        smoothScrollToReviews(-90);
      } catch (e) {
        // no-op
      }
    };

    try {
      document.addEventListener('click', handler, { capture: false, passive: false });
    } catch (e) {
      document.addEventListener('click', handler, false);
    }
  }

  onReady(function () {
    initLooxScrollHandler();
  });
})();
